(function () {
  const DEBUG = 0; // Mettre à 1 pour activer les logs

  const whatsappFloat = document.getElementById("whatsapp-float");
  if (!whatsappFloat) return;

  // Réglages en dur
  const scrollThreshold = 700;
  const pageHeightThreshold = 2000;
  const showOnDesktop = true;

  let isDesktop = window.innerWidth > 768;
  let ticking = false;
  let footer = null;
  let footerHeight = 0;

  // Trouve le footer
  function findFooter() {
    // Cherche le footer réel (classe .footer en priorité)
    footer =
      document.querySelector("footer.footer") ||
      document.querySelector("footer") ||
      document.querySelector('[data-section-type="footer"]');

    if (!footer) {
      const sections = document.querySelectorAll('[id^="shopify-section-"]');
      footer = sections[sections.length - 1] || null;
    }
  }

  // Calcule la hauteur du footer
  function calculateFooterHeight() {
    if (footer) {
      const height = footer.getBoundingClientRect().height;
      footerHeight = height + 5;

      if (DEBUG) {
        console.log("📏 Footer trouvé:", footer.className || footer.tagName);
        console.log("📏 Hauteur réelle:", height, "px");
        console.log("📏 Seuil utilisé:", footerHeight, "px");
      }
    }
  }

  // Fonction pour vérifier si on doit afficher le bouton
  function shouldShowButton() {
    const scrollY = window.scrollY || window.pageYOffset;
    const documentHeight = document.documentElement.scrollHeight;

    if (isDesktop) {
      return showOnDesktop;
    }

    if (documentHeight < pageHeightThreshold) {
      return true;
    }

    return scrollY >= scrollThreshold;
  }

  // Fonction principale - basée sur la distance de scroll
  function checkOffset() {
    const show = shouldShowButton();
    whatsappFloat.classList.toggle("wa-hidden", !show);

    const scrollY = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Distance depuis le bas de la page (en pixels)
    const distanceFromBottom = documentHeight - (scrollY + windowHeight);

    // Si on est proche du bas (hauteur du footer) → passe en absolute
    if (footerHeight > 0 && distanceFromBottom <= footerHeight) {
      whatsappFloat.classList.remove("wa-fixed");
      whatsappFloat.classList.add("wa-absolute");
    }
    // Sinon → reste/repasse en fixed
    else {
      whatsappFloat.classList.remove("wa-absolute");
      whatsappFloat.classList.add("wa-fixed");
    }

    ticking = false;
  }

  // Optimisation avec requestAnimationFrame
  function requestUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(checkOffset);
      ticking = true;
    }
  }

  // Gestion du resize
  let resizeTimeout;
  function handleResize() {
    // Debounce: Chrome déclenche beaucoup d'events resize (responsive toolbar).
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      isDesktop = window.innerWidth > 768;
      calculateFooterHeight(); // Recalcule au resize
      requestUpdate();
    }, 150);
  }

  // Initialisation
  function init() {
    findFooter();
    // Ajoute la classe fixed par défaut
    whatsappFloat.classList.add("wa-fixed");

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", handleResize, { passive: true });

    // Calcul et check UNIQUEMENT après le chargement complet
    window.addEventListener("load", () => {
      calculateFooterHeight();
      checkOffset();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
